// @ts-nocheck
import React from 'react';
import { IconButton, Box } from '@mui/material';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { DeleteIcon, DownloadIcon } from 'assets/icons';
import { other } from 'assets/colors';
import {
  handleDownload,
  handleDownloadExcel,
  handleRemoveFile,
} from '../../../AttachmentUtils';

const FileActions = ({
  file,
  fileAttach,
  setFileAttach,
  classes,
  handleDirty,
}) => {
  const [{ mode }] = useCustomForm();
  const handleDelete = (e) => {
    e.stopPropagation();
    handleRemoveFile(file, fileAttach, setFileAttach);
    if (mode === 'add' || mode === 'edit') {
      handleDirty();
    }
  };
  return (
    <Box className={classes.onHover}>
      <Box className={classes.iconButtonContainer}>
        <IconButton
          className={classes.actionIconButton}
          aria-label="download"
          onClick={() => {
            file?.name?.split('.', 2)[1] ===
            ('xlsx' || 'xlsm' || 'xlsb' || 'xls')
              ? handleDownloadExcel(file?.file)
              : handleDownload(file?.file);
          }}
        >
          <DownloadIcon sx={{ color: other.icon, fontSize: '12px' }} />
        </IconButton>
      </Box>
      <Box className={classes.iconButtonContainer}>
        <IconButton
          className={classes.actionIconButton}
          aria-label="delete"
          onClick={handleDelete}
        >
          <DeleteIcon sx={{ color: other.icon, fontSize: '12px' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FileActions;
